import { RedempResponse } from "./../../../shared/interfaces/unauth-redemp";
import { TransactionInfo } from "./../../../shared/interfaces/transaction-info";
import { ConfirmOrderResponse } from "./../../../customer-lucky/share/interface/customerLucky";
import { ProductDetail, CreateOrderResponse } from "./../interface/GiftItem";
import { Config } from "./../../../config/config";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { GiftItem } from "../interface/GiftItem";
import { EditTicketCounter } from "app/shared/interfaces/pos-model";
import { AppConsts } from "app/shared/consts/app-consts";
import { CampaignInfo } from "app/shared/interfaces/campaign-info";

@Injectable({
  providedIn: "root",
})
export class GiveGiftService {
  constructor(private apiService: ApiService) {}

  public GetProductsByStaff(
    applyMachanic: boolean,
    invoiceHeaderId: string,
    screenName: string
  ): Observable<GiftItem[]> {
    return this.apiService.get<GiftItem[]>(
      applyMachanic
        ? `${Config.unileverApiPath.getMechanicProductsByStaff}?invoiceHeaderId=${invoiceHeaderId}&screenName=${screenName}`
        : `${Config.unileverApiPath.getProductsByStaff}`,
      environment.unileverApiHost
    );
  }

  public CreateOrder(
    uid: string,
    productDetail: ProductDetail[],
    invoiceHeaderId: string,
    note: string,
    loyaltyPoint: number
  ) {
    var currentTransactionId = localStorage.getItem(
      AppConsts.currentTransactionId
    );
    const postData = {
      userId: uid,
      type: "CreateOrder",
      fileId: "",
      products: productDetail,
      invoiceHeaderId: invoiceHeaderId,
      extraNote: note,
      loyaltyPoint: loyaltyPoint,
      transactionId: currentTransactionId,
    };
    return this.apiService.post<CreateOrderResponse>(
      Config.unileverApiPath.createOrder,
      postData,
      environment.unileverApiHost
    );
  }

  public CreatePosOrder(
    uid: string,
    posId: string,
    productDetail: ProductDetail[]
  ) {
    const postData = {
      type: "CreateOrder",
      fileId: "",
      products: productDetail,
      extraNote: posId,
      userId: uid,
    };
    return this.apiService.post<CreateOrderResponse>(
      Config.unileverApiPath.createPostOrder,
      postData,
      environment.unileverApiHost
    );
  }

  public ConfirmOrder(
    uid: string,
    otp: string,
    skip: boolean,
    unauth: boolean = false
  ): Observable<ConfirmOrderResponse> {
    const postData = {
      uid: uid,
      otp: otp,
      isShoper: false,
      skipFlg: skip,
    };
    if (!unauth) {
      return this.apiService.post<ConfirmOrderResponse>(
        Config.unileverApiPath.confirmOrder,
        postData,
        environment.unileverApiHost
      );
    } else {
      return this.apiService.post<ConfirmOrderResponse>(
        Config.unileverApiPath.unauthConfirmOrder,
        postData,
        environment.unileverApiHost
      );
    }
  }

  public getRemainTimeConfirmCode(orderCode: string) {
    return this.apiService.get<number>(
      `${Config.unileverApiPath.getRemainTimeConfirm}?orderCode=${orderCode}`,
      environment.unileverApiHost
    );
  }
  public getRemainTimeConfirmByCode(codeId: string) {
    return this.apiService.get<number>(
      `${Config.unileverApiPath.getRemainTimeConfirmByCode}?code=${codeId}`,
      environment.unileverApiHost
    );
  }

  public getEditTicketCounter() {
    return this.apiService.get<EditTicketCounter>(
      Config.unileverApiPath.getEditTicketCounter,
      environment.unileverApiHost
    );
  }

  public GetProductsByConfig(): Observable<GiftItem[]> {
    return this.apiService.get<GiftItem[]>(
      `${Config.unileverApiPath.getProductsByConfig}`,
      environment.unileverApiHost
    );
  }

  public GetTransactionInfo(data: any): Observable<TransactionInfo> {
    return this.apiService.post<TransactionInfo>(
      `${Config.unileverApiPath.getTransactionInfo}`,
      data,
      environment.unileverApiHost
    );
  }

  public RandomGift(data: any): Observable<RedempResponse> {
    return this.apiService.post<RedempResponse>(
      `${Config.unileverApiPath.randomGift}`,
      data,
      environment.unileverApiHost
    );
  }

  public Redemp(data: any): Observable<RedempResponse> {
    return this.apiService.post<RedempResponse>(
      `${Config.unileverApiPath.unAuthRedemp}`,
      data,
      environment.unileverApiHost
    );
  }

  public GetCurrentMaxgift(userId: string): Observable<number> {
    return this.apiService.get<number>(
      `${Config.unileverApiPath.getCurrentMaxGift}?userId=${userId}`,
      environment.unileverApiHost
    );
  }

  public getCampaignInfo() {
    return this.apiService.get<CampaignInfo>(
      Config.unileverApiPath.campaignInfo,
      environment.apiQuatangunilever
    );
  }
}
